export default {
  methods: {
    translate(type, data) {
      let lang = this.$i18n.locale;
      if (type === "name") {
        return data.trans ? data.trans.name[lang] : data.name;
      }
      if (type === "description") {
        return data.trans ? data.trans.description[lang] : data.description;
      }
      if (type === "item") {
        return data.trans ? data.trans[lang] : data.item;
      }
      if (type === "order") {
        return data.order_translations
          ? data.order_translations[lang]
          : data.name;
      }
    },
    translateToOneLang(type, data, lang) {
      if (type === "name") {
        return data.trans ? data.trans.name[lang] : data.name;
      }
      if (type === "description") {
        return data.trans ? data.trans.description[lang] : data.description;
      }
      if (type === "item") {
        return data.trans ? data.trans[lang] : data.item;
      }
    }
  }
};
